<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Incidents from './incidents'

import axios from 'axios'

export default {
	page: {
		title: 'Incidents Triage List',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Incidents },
	data() {
		return {
			title: 'Incidents Triage List',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Incidents Triage List',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Incidents 
							:url = "'/pan/xdr/incidents?include=incident.incident&status=new'"
							:description = "'Incidents to Triage'"
						/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
